














import { Component, Prop, Watch, Ref, Vue } from 'vue-property-decorator'
import { IRedactorX } from '~/types/interfaces/Redactorx'

import { getRenderedIconHTML } from '~/configs/editor'
import { htmlToElement } from '~/utils/browserExtendedAPI'
import { loadEditorAssets } from '~/utils/redactor'
import ContentManager from '~/modules/content/ContentManager'

@Component
export default class Redactorx extends Vue {
  @Prop({
    default: '',
    type: String
  })
  value: string

  @Prop({
    type: String,
    default: null
  })
  placeholder: null | string

  @Prop({
    type: String,
    default: null
  })
  name: null | string

  @Prop({
    default: () => ({}),
    type: Object
  })
  config: Record<string, any>

  @Prop({
    type: Boolean,
    default: true
  })
  conditionToShow: boolean

  @Prop({
    type: Array,
    default: () => ([])
  })
  plugins: string[]

  @Prop({
    type: Boolean,
    default: false
  })
  focus: boolean

  @Prop({
    type: Boolean,
    default: true
  })
  showDeleteImage: boolean

  @Ref('redactorxContainer')
  redactorxContainer: HTMLElement

  loading = true

  redactorx: null | IRedactorX = null

  interval = 0

  @Watch('value')
  onValChange (newValue) {
    if (!this.redactorx!.editor.isFocus()) {
      this.redactorx!.app.$element.val(newValue)
    }
  }

  // v-show не работает для самого элемента редактора .rx-container
  @Watch('conditionToShow')
  onShowChange () {
    const el = this.redactorxContainer.querySelector('.rx-container')! as HTMLDivElement

    if (!el) return

    el.style.display = this.conditionToShow
      ? 'block'
      : 'none'
  }

  mounted () {
    loadEditorAssets()
    this.interval = window.setInterval(this.initRedactor, 100)
  }

  destroy () {
    if (!this.redactorx) return

    // Call destroy on redactor to cleanup event handlers
    window.RedactorX(this.$refs.redactorx, 'destroy')

    // unset instance for garbage collection
    this.redactorx = null
    // this.$parent.redactorx = null
  }

  beforeDestroy () {
    this.destroy()
  }

  handleInput (val) {
    this.$emit('input', val)
  }

  initRedactor () {
    if (window.RedactorX && this.$refs.redactorxContainer) {
      window.clearInterval(this.interval)
      this.setupRedactor()
    }
  }

  setupRedactor () {
    if (this.redactorx) return

    this.$emit('before-init', this.redactorx)

    const subscribe = {
      'editor.change': event => {
        const html = event.get('html')

        this.handleInput(html)

        return html
      },
      'app.start': async () => {
        this.loading = false

        await this.$nextTick()

        if (this.focus) {
          const rxEditor = this.redactorxContainer.querySelector('.rx-editor') as HTMLElement
          rxEditor.click()
          this.redactorx!.caret.set(rxEditor, 'end')
        }

        // необходимо для отображения иконок до фокуса
        this.redactorx!.toolbar._checkIntialToolbar(0)
        this.redactorx!.toolbar.enable()
      },
      'editor.blur': () => {
        this.$nextTick().then(() => this.redactorx?.toolbar._checkIntialToolbar(0))
      },
      'editor.before.paste': event => {
        const html = event.get('html')

        event.set('html', ContentManager.prepareEditorContent(html))
        this.$nextTick(this.initDeleteBtnOnImages.bind(this))
      }
    }

    if (typeof this.config.subscribe === 'undefined') {
      Vue.set(this.config, 'subscribe', subscribe)
    } else {
      this.config.subscribe = subscribe
    }

    this.redactorx = window.RedactorX(this.$refs.redactorx, {
      ...this.config,
      plugins: this.plugins,
      editor: {
        ...this.config.editor || null,
        lang: 'ru'
      },
      embed: {
        checkbox: true,
        script: false
      }
    })

    this.initDeleteBtnOnImages()
    this.$emit('init', this.redactorx)
    // this.$parent.redactorx = app
  }

  initDeleteBtnOnImages () {
    if (!this.showDeleteImage) {
      return
    }

    const figureSelector = 'figure[data-rx-type="image"]'

    this.redactorxContainer
      .querySelectorAll(figureSelector)
      .forEach(async figure => {
        if (figure.querySelector('.rx-delete-img-btn')) return

        const btnEl = htmlToElement(`
          <div class="rx-delete-img-btn">
            ${await getRenderedIconHTML('common/x')}
          </div>
        `)

        btnEl.addEventListener('click', () => {
          // Удаляет картинку
          figure.remove()
        })

        figure.append(btnEl)
      })
  }

  /*
    Общая для редактора подготовка к выдаче финального контента
    Используется через $refs
   */
  prepareContentBeforeGetResultCommon () {
    /*
      Обработка кнопки удаления у картинок
     */
    document.querySelectorAll('.rx-delete-img-btn')
      // Удаляет кнопки чтобы они не сохранялись как HTML элементы в БД и тем самым не создавали лишний отступ для картинок
      .forEach(btn => btn.remove())
  }
}
